
import { Component, Mixins } from "vue-property-decorator";
import { ImageKinds } from "../../../../../domain/document";
import { SignItem } from "../../../../../domain/document/items";
import { CommonComponentsAccessor } from "../../CommonComponentsAccessor";

@Component
export default class SignExecutableMixin extends Mixins() {
  editingSource: SignItem;
  writePropertyWhenValid: (writer: (source: SignItem) => void) => void;
  commonComponents: CommonComponentsAccessor;

  async executeSign(): Promise<void> {
    const result = await this.commonComponents.adapters.sign.executeSign(this.editingSource);
    if (result && result.isComplete) {
      this.writePropertyWhenValid(s => {
        s.clearImageInformation();
        s.imageSource = result.imageSource;
        s.imageKind = ImageKinds.Image;
        s.signatureGuid = result.signatureCacheGuid;  // キャッシュと同じGuidで登録
        s.signatureCacheGuid = result.signatureCacheGuid;
      });
    }
  }
}
